module.exports = __webpack_public_path__ + "static/img/4.6b1e4e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kite-surf/4.jpg
// module id = uTXZ
// module chunks = 1